<template>
  <div id="app">
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  mounted(){
    console.log(this.$route.fullPath);
    let vars = this.$route.fullPath.split("?")[1].replace('amp;','').replace('amp%3B','');
    console.log(vars)
    // window.top.location.href = "https://jd-2c-qnr-h5-dev.devops-jdp.com/ref?"+vars
    window.top.location.href = "https://wechat-callback.jdponline.cn/ref?"+vars
    // let url = "https://jd-service-dev-ssl.devops-jdp.com/plat-qnr/qnr/updateUserJoinStatus?"+vars;
  },
  methods:{


  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/page/QnrFinish/QnrFinish.vue